/**
 * Auth Service Public API
 *
 * External code should ONLY import from this file.
 * Provider implementations are not exposed.
 */

import { isOnPrem, isExternalDemo } from '../../config'
import useAuth0Auth from './hooks/useAuth0Auth'
import useOnPremAuth from './hooks/useOnPremAuth'
import useDemoAuth from './hooks/useDemoAuth'

// Compile-time hook selection based on environment
// At build time, webpack replaces process.env.REACT_APP_ENV,
// allowing dead code elimination to remove unused implementations
let useAuthImpl
if (isOnPrem) {
  useAuthImpl = useOnPremAuth
} else if (isExternalDemo) {
  useAuthImpl = useDemoAuth
} else {
  useAuthImpl = useAuth0Auth
}
export const useAuth = useAuthImpl

// Types
export type { AuthHook, User, LogoutOptions } from './types'
// For backward compatibility
export type { AuthHook as AuthProvider } from './types'
